module.exports = __webpack_public_path__ + "img/ftpay-link.719a195e.png";